import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SimpleFooter = () => {

    const { t } = useTranslation();

    useEffect(() => {
        
		// scroll to top
		if (document.querySelector('.tap-top') !== null) {
			// scroll to top
			document.querySelector('.tap-top').addEventListener('click', () => {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			})

			// scroll event listener
			document.addEventListener('scroll', () => {
				if (document.querySelector('.tap-top') !== null) {
					if (window.scrollY > 500) {
						document.querySelector('.tap-top').classList.add('show')
					} else {
						document.querySelector('.tap-top').classList.remove('show')
					}
				}

			})
        }
        
	},[])

    return (
        <div className="bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="copyright-section">
                            <p>{t('copyright text', { year: new Date().getFullYear() })}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tap-top">
                <div>
                    <i className="fa fa-angle-double-up"></i>
                </div>
            </div>
        </div>
    )

}

export default SimpleFooter


// WEBPACK FOOTER //
// ./src/components/simpleFooter.js